// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaPage_container__t3KwL {
    background-color: #000;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  
  .MediaPage_title__RGOAX {
    color: #fff;
    font-size: 2.5rem;
    margin-bottom: 3rem;
    text-align: center;
    text-transform: uppercase;
    border-bottom: 2px solid #ff0000;
    padding-bottom: 0.5rem;
  }
  
  .MediaPage_gridContainer__0UYZl {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    width: 100%;
    max-width: 1200px;
  }
  
  .MediaPage_card__8e1XO {
    background-color: rgba(40, 40, 40, 0.8);
    border-radius: 10px;
    padding: 2rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #333;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    height: 200px;
  }
  
  .MediaPage_card__8e1XO:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(255, 0, 0, 0.2);
    background-color: rgba(50, 50, 50, 0.9);
    border: 1px solid #ff0000;
  }
  
  .MediaPage_iconContainer__3mu2B {
    font-size: 3rem;
    color: #ff0000;
    margin-bottom: 1rem;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .MediaPage_icon__Z82VY {
    width: 3rem;
    height: 3rem;
    stroke: #ff0000;
    stroke-width: 1.5;
    transition: all 0.3s ease;
  }
  
  .MediaPage_card__8e1XO:hover .MediaPage_iconContainer__3mu2B {
    transform: scale(1.2);
  }
  
  .MediaPage_card__8e1XO:hover .MediaPage_icon__Z82VY {
    stroke: #ff3333;
  }
  
  .MediaPage_categoryName__lt3QC {
    color: #fff;
    text-align: center;
    font-size: 1.5rem;
    margin: 0;
  }
  
  .MediaPage_componentContainer__kGoI5 {
    width: 100%;
    max-width: 1200px;
  }
  
  .MediaPage_backButton__YmSab {
    background-color: transparent;
    color: #ff0000;
    border: 1px solid #ff0000;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 2rem;
    transition: all 0.3s ease;
    font-size: 1rem;
  }
  
  .MediaPage_backButton__YmSab:hover {
    background-color: #ff0000;
    color: #fff;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .MediaPage_gridContainer__0UYZl {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .MediaPage_title__RGOAX {
      font-size: 2rem;
    }
    
    .MediaPage_icon__Z82VY {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
  
  @media (max-width: 480px) {
    .MediaPage_gridContainer__0UYZl {
      grid-template-columns: 1fr;
    }
    
    .MediaPage_container__t3KwL {
      padding: 1rem;
    }
    
    .MediaPage_title__RGOAX {
      font-size: 1.8rem;
    }
    
    .MediaPage_card__8e1XO {
      height: 180px;
    }
    
    .MediaPage_icon__Z82VY {
      width: 2.2rem;
      height: 2.2rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/Media/MediaPage.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,yCAAyC;IACzC,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,4CAA4C;IAC5C,uCAAuC;IACvC,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA,2BAA2B;EAC3B;IACE;MACE,qCAAqC;IACvC;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,cAAc;IAChB;EACF;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,cAAc;IAChB;EACF","sourcesContent":[".container {\n    background-color: #000;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  \n  .title {\n    color: #fff;\n    font-size: 2.5rem;\n    margin-bottom: 3rem;\n    text-align: center;\n    text-transform: uppercase;\n    border-bottom: 2px solid #ff0000;\n    padding-bottom: 0.5rem;\n  }\n  \n  .gridContainer {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 2rem;\n    width: 100%;\n    max-width: 1200px;\n  }\n  \n  .card {\n    background-color: rgba(40, 40, 40, 0.8);\n    border-radius: 10px;\n    padding: 2rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border: 1px solid #333;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    height: 200px;\n  }\n  \n  .card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 25px rgba(255, 0, 0, 0.2);\n    background-color: rgba(50, 50, 50, 0.9);\n    border: 1px solid #ff0000;\n  }\n  \n  .iconContainer {\n    font-size: 3rem;\n    color: #ff0000;\n    margin-bottom: 1rem;\n    transition: all 0.3s ease;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .icon {\n    width: 3rem;\n    height: 3rem;\n    stroke: #ff0000;\n    stroke-width: 1.5;\n    transition: all 0.3s ease;\n  }\n  \n  .card:hover .iconContainer {\n    transform: scale(1.2);\n  }\n  \n  .card:hover .icon {\n    stroke: #ff3333;\n  }\n  \n  .categoryName {\n    color: #fff;\n    text-align: center;\n    font-size: 1.5rem;\n    margin: 0;\n  }\n  \n  .componentContainer {\n    width: 100%;\n    max-width: 1200px;\n  }\n  \n  .backButton {\n    background-color: transparent;\n    color: #ff0000;\n    border: 1px solid #ff0000;\n    padding: 0.5rem 1rem;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-bottom: 2rem;\n    transition: all 0.3s ease;\n    font-size: 1rem;\n  }\n  \n  .backButton:hover {\n    background-color: #ff0000;\n    color: #fff;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .gridContainer {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .title {\n      font-size: 2rem;\n    }\n    \n    .icon {\n      width: 2.5rem;\n      height: 2.5rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .gridContainer {\n      grid-template-columns: 1fr;\n    }\n    \n    .container {\n      padding: 1rem;\n    }\n    \n    .title {\n      font-size: 1.8rem;\n    }\n    \n    .card {\n      height: 180px;\n    }\n    \n    .icon {\n      width: 2.2rem;\n      height: 2.2rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaPage_container__t3KwL`,
	"title": `MediaPage_title__RGOAX`,
	"gridContainer": `MediaPage_gridContainer__0UYZl`,
	"card": `MediaPage_card__8e1XO`,
	"iconContainer": `MediaPage_iconContainer__3mu2B`,
	"icon": `MediaPage_icon__Z82VY`,
	"categoryName": `MediaPage_categoryName__lt3QC`,
	"componentContainer": `MediaPage_componentContainer__kGoI5`,
	"backButton": `MediaPage_backButton__YmSab`
};
export default ___CSS_LOADER_EXPORT___;
